import { render } from "./detail.vue?vue&type=template&id=54a96cce&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"

import "./detail.vue?vue&type=style&index=0&id=54a96cce&scoped=true&lang=css"

import exportComponent from "/Users/home/Documents/kevin/matrix_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54a96cce"]])

export default __exports__